module.exports = __webpack_public_path__ + "static-portal/img/19.521570e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/19.jpg
// module id = pP2O
// module chunks = 4